import { gql, TypedDocumentNode } from '@apollo/client'

import { ATTRIBUTE_FRAGMENT } from './attribute'

import type { AbTestsVariantsSchemaDTO } from 'features/ab-tests/api/types/abTestsVariantsSchemaDTO'

export const REFRESHER_FRAGMENT: TypedDocumentNode<AbTestsVariantsSchemaDTO['refresher']> = gql`
  ${ATTRIBUTE_FRAGMENT}

  fragment abTestsVariantsRefresherFragment on AbTestsVariantsRefresher {
    basicSettings {
      label
      desktopAdThreshold {
        ...abTestsVariantsAttributesFragment
      }
      desktopMonitorUserScrollEnabled {
        ...abTestsVariantsAttributesFragment
      }
      desktopRefreshInterval {
        ...abTestsVariantsAttributesFragment
      }
      mobileAdThreshold {
        ...abTestsVariantsAttributesFragment
      }
      mobileMonitorUserScrollEnabled {
        ...abTestsVariantsAttributesFragment
      }
      mobileRefreshInterval {
        ...abTestsVariantsAttributesFragment
      }
    }
    label
  }
`
